import React, { useState, useEffect } from "react";
import axios from 'axios';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
function SettlementReport() {
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("");
  const [search, setSearch] = useState("");
  const [fetchQuick, setFetchQuick] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [withdrawal, setWithdrawal] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const getCurrentMonth = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  };
  const [selectedMonth, setSelectedMonth] = useState(getCurrentMonth());
  const fetchQuickService = async () => {
    try {
      const res = await axios.get(`https://api.sweepydo.in/fetch-all-quick-service?from=${fromDate}&to=${toDate}`);
      setFetchQuick(res.data);
      // console.log(res.data,'quick service');
    } catch (error) {
      console.log(error);
    }
  };
  const fetchSubHistory = async () => {
    try {
      const res = await axios.get(`https://api.sweepydo.in/fetch-subscription-history?from=${fromDate}&to=${toDate}`);
      setData(res.data);

      // console.log(res.data,'sub history');
    } catch (error) {
      console.log(error);
    }
  };
  const fetchWithdrawal = async () => {
    try {
      const res = await axios.get(`https://api.sweepydo.in/fetch-staff-wthdrawal?from=${fromDate}&to=${toDate}`);
      setWithdrawal(res.data);
      // console.log(res.data ,'with');
    } catch (error) {
      console.log(error);
    }
  };
  const generateSettlement = (withdrawal, subHistory, serviceHistory) => {
    let result = [];

    // 🔻 Withdrawal (always negative)
    withdrawal.forEach(w => {
      result.push({
        date: w.req_on,
        type: "Withdrawal",
        name: w.staff_name,
        mode: w.pay_mode,
        amount: -Number(w.amount),
        status: w.pay_status
      });
    });
    subHistory.forEach(s => {
      const isWallet = s.payment_mode?.toLowerCase() === "wallet";
      result.push({
        date: s.rec_date,
        type: "Subscription",
        name: s.user_name,
        mode: s.payment_mode,
        amount: isWallet ? -Number(s.amount) : Number(s.amount),
        status: s.status,
        coins: s.coins || 0
        // coins: -Math.abs(Number(s.coins || 0))
      });
    });

    // 🔻 Quick Service
    serviceHistory.forEach(q => {
      const isWallet = q.pay_mode?.toLowerCase() === "wallet";
      const isCancelled = q.service_status === "Cancelled";
      const amount = Number(q.amount);
      result.push({
        date: q.created_on,
        type: "Service",
        name: q.users_name,
        mode: q.pay_mode,
        // amount: isWallet ? -Number(q.amount) : Number(q.amount),
        amount: isWallet || isCancelled ? -Math.abs(amount) : Math.abs(amount),
        status: q.pay_status
      });
    });
    return result;
  };
  const settlement = generateSettlement(withdrawal, data, fetchQuick);
  const sortedSettlement = settlement.sort((a, b) => new Date(b.date) - new Date(a.date));
  useEffect(() => {
    fetchQuickService();
    fetchSubHistory();
    fetchWithdrawal();
  }, []);
  useEffect(() => {
    if (fromDate && toDate) {
      fetchQuickService();
      fetchSubHistory();
      fetchWithdrawal();
    }
  }, [fromDate, toDate]);
  const filteredData = Array.isArray(sortedSettlement) ? sortedSettlement.filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  const parsedService = selectedRow?.service ? JSON.parse(selectedRow.service) : [];
  const parsedAddress = selectedRow?.address ? JSON.parse(selectedRow.address) : {};
  const handleDownloadExcel = () => {
    setIsExporting(true);
    setTimeout(() => {
      const exportData = sortedSettlement.map((item, i) => ({
        SN: i + 1,
        Date: item.date,
        Type: item.type,
        "User/Staff": item.name,
        Mode: item.mode,
        Status: item.status,
        Amount: item.amount
      }));
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Settlement");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      const data = new Blob([excelBuffer], {
        type: "application/octet-stream"
      });
      saveAs(data, "Settlement_Report.xlsx");
      setIsExporting(false);
    }, 100);
  };
  return <div className="container-fluid mt-1 p-4" style={{
    minHeight: "100vh"
  }}>

            <h2 className="text-center mb-4 text-white">Settlement Report </h2>

            <div style={{
      background: "var(--black)",
      borderRadius: "12px",
      padding: "15px"
    }}>
                {!isExporting && <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 ">


                    <div style={{
          minWidth: "250px"
        }}>
                        <input type="text" className="form-control p-2 "
          // style={{ maxWidth: "300px" }}
          placeholder="Search plan..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} style={{
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #334155"
          }} />
                    </div>



                    <div className="d-flex align-items-center gap-3 flex-wrap">


                        <input type="date" className="form-control" value={fromDate} onChange={e => setFromDate(e.target.value)} style={{
            width: "180px",
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #334155"
          }} />

                        <input type="date" className="form-control" value={toDate} onChange={e => setToDate(e.target.value)} style={{
            width: "180px",
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #334155"
          }} />



                    </div>
                </div>}

                <div className="d-flex justify-content-end mb-3">
  <button className="btn btn-success" onClick={handleDownloadExcel}>
    Download Excel
  </button>
</div>

                <div className='table-responsive '>
                    <table className="text-center" style={{
          width: "100%",
          borderCollapse: "collapse",
          color: "#fff"
        }}>

                        <thead>
                            <tr style={{
              backgroundColor: "var(--black2)"
            }}>
                                <th style={{
                padding: "18px",
                textAlign: "center",
                background: "var(--black2)",
                color: '#fff'
              }}>SN</th>
                                  <th style={{
                padding: "18px",
                textAlign: "center",
                background: "var(--black2)",
                color: '#fff'
              }}>DATE</th>
                                <th style={{
                padding: "18px",
                textAlign: "center",
                background: "var(--black2)",
                color: '#fff'
              }}>TYPE</th>
                                <th style={{
                padding: "18px",
                textAlign: "center",
                background: "var(--black2)",
                color: '#fff'
              }}>USER / STAFF </th>
                              

                                <th style={{
                padding: "18px",
                textAlign: "center",
                background: "var(--black2)",
                color: '#fff'
              }}>MODE</th>
                                <th style={{
                padding: "18px",
                textAlign: "center",
                background: "var(--black2)",
                color: '#fff'
              }}>STATUS</th>
                                <th style={{
                padding: "18px",
                textAlign: "center",
                background: "var(--black2)",
                color: '#fff'
              }}>AMOUNT</th>
                                 <th style={{
                padding: "18px",
                textAlign: "center",
                background: "var(--black2)",
                color: '#fff'
              }}>Coins</th>


                            </tr>
                        </thead>


{filteredData.map((item, i) => <tr key={i} style={{
            backgroundColor: "var(--black)",
            borderBottom: "1px solid rgba(255,255,255,0.06)",
            transition: "0.3s"
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = "var(--black2)";
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = "var(--black)";
          }}>

     <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{i + 1}</td>
    <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{item.date}</td>
    <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{item.type}</td>
    <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{item.name}</td>
    <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{item.mode}</td>
    <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{item.status} </td>
    <td style={{
              color: item.amount < 0 ? "red" : "green",
              padding: "18px",
              textAlign: "center"
            }}>
      {item.amount < 0 ? "-" : "+"}₹{Math.abs(item.amount)}
    </td>
     <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{item.coins || '-'} </td>
  </tr>)}
                    </table>
                </div>



            </div>
        </div>;
}
export default SettlementReport;
